import { BaseDto } from "src/dtos/common/baseDto";

/** hrm_break_time(휴게시간)의 API 필드와 그리드의 신규·수정 상태를 표현한다. 복합키는 shiftCd + breakSeq이다. */
export interface HrmBreakTimeDto extends BaseDto {
    shiftCd: string; // 휴게가 속한 근무조코드. 저장 시 서버가 선택 근무조의 코드로 덮어쓴다.
    breakSeq: number | null; // 근무조 안의 순번. 신규 행은 null로 보내고 서버가 번호를 붙인다.
    breakNm: string; // 휴게명 (오전휴식·점심시간 등)
    fromTime: string; // 휴게 시작(HH:MM)
    toTime: string; // 휴게 종료(HH:MM). 시작보다 작으면 다음날로 본다.
    excludeYn: string; // 근무제외(Y/N). Y는 근무·연장·야간에서 빼고, N은 근무로 인정한다. 지각·조퇴·외출에서는 둘 다 뺀다.
    useYn: string; // 사용여부(Y/N). N이면 시간 계산과 겹침 검사에서 제외한다.
    remark: string; // 비고
    inserted: boolean; // true이면 아직 저장하지 않은 신규 행
    isModified: boolean; // true이면 조회 후 값이 바뀐 기존 행
}

/** 신규 휴게 행의 기본값이다. 실행 샘플과 같이 근무제외·사용을 Y로 시작한다. */
export const defaultHrmBreakTimeDto: HrmBreakTimeDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    shiftCd: '',
    breakSeq: null,
    breakNm: '',
    fromTime: '',
    toTime: '',
    excludeYn: 'Y',
    useYn: 'Y',
    remark: '',
    inserted: false,
    isModified: false,
};
